import {ValidationResult} from "../../../util/validation/validation-result"

export interface ComputeGenericValue {
  description: string
  value: string
  partialValidationResult: ValidationResult
  validationResult: ValidationResult
}

export interface ComputeNumericValue extends ComputeGenericValue {
  numericValue: number | undefined
}

export const getInitialComputeNumericValue = (numericValue: number, description: string): ComputeNumericValue => {
  return {
    description,
    numericValue: numericValue,
    value: numericValue.toString(),
    validationResult: {valid: true},
    partialValidationResult: {valid: true}
  }
}
export const getInitialComputeGenericValue = (value: string, description: string): ComputeGenericValue => {
  return {
    description,
    value: value,
    validationResult: {valid: true},
    partialValidationResult: {valid: true}
  }
}